import { Container, makeStyles, Paper } from "@material-ui/core";

import { Motivation } from "./Motivation";
import { Level } from "./Level";
import { MouseEventHandler, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { Cooperation } from "../../gardener/gardener.model";

const useStyles = makeStyles(theme => ({
    card: {
        overflow: "hidden",
        padding: "16px 24px",

        [theme.breakpoints.down(500)]: {
            padding: "16px",
        },

        "& > *": {
            marginBottom: "16px",

            "&:last-child": {
                marginBottom: 0,
            },
        },
    },
    header: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",

        "& > h3": {
            fontSize: "16px",
            fontWeight: 600,
            color: "#4A4A4A",

            margin: 0,
        },
        "& > a": {
            fontSize: "16px",
            fontWeight: 600,
            color: "#297A1D",
            textDecoration: "none",
    
            "&:hover": {
                color: "#1C5B13",
                textDecoration: "underline",
            },
        },
    },
    paragraph: {
        fontSize: "16px",
        fontWeight: 400,
        color: "#4A4A4A",

        [theme.breakpoints.down(1100)]: {
            textAlign: "center",
        },
    },
    levels: {
    },
    divider: {
        backgroundColor: "#000000",
        opacity: 0.2,
        height: "1px",
    },
    motivation: {
        fontSize: "14px",
        fontWeight: 400,
        color: "#4A4A4A",
        textAlign: "center",
    },
}));

interface YourLevelSimpleCardProps {
    cooperation: Cooperation;
}

export const YourLevelSimpleCard = (props: YourLevelSimpleCardProps) => {
    const classes = useStyles();
    const { cooperation } = props;

    const history = useHistory();
    const cooperationPagePath = "/cooperation";
    const goToCooperationPage = useCallback<MouseEventHandler>((event) => {
        event.preventDefault();

        history.push(cooperationPagePath);
    }, [history, cooperationPagePath]);

    return (
        <Container maxWidth="md" disableGutters>
            <Paper className={classes.card}>

                <div className={classes.header}>
                    <h3>Vores samarbejde</h3>
                    <a href={cooperationPagePath} onClick={goToCooperationPage}>Læs mere</a>
                </div>

                <Level cooperationLevel={cooperation.level} selected dense />

                <div className={classes.divider} />

                <Motivation cooperation={cooperation} />

            </Paper>
        </Container>
    );
};
